import React from "react"

import { Container } from "@material-ui/core"

// import hero from "./../assets/hero-transparent.png"


export default function Hero({ children }) {  
  return (   

    <div className="hero">
    {/*
    <img src={hero} alt=" "/>

    */}
    <div className="text">
    <Container> 
      {children}
    </Container>
    </div>
    </div>     

  )
}
